const defaultTheme = "darker";

enum colourThemes {
    darkest = "darkest",
    darker = "darker",
    lighter = "lighter",
    lightest = "lightest"
}

export { colourThemes, defaultTheme };